import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { LoginLayout } from '@/components/modules/Layout/LoginLayout';
import { LoginForm } from '@/components/modules/pages/login/Form/LoginForm';
/**
 * ログイン画面 View
 * @param props
 * @returns
 */
export const LoginView = (props) => {
    const { className = '', customErrorCallback, onSubmit } = props;
    return (_jsx(LoginLayout, Object.assign({ className: className, title: 'ログイン' }, { children: _jsx(LoginForm, { className: 'p-32', customErrorCallback: customErrorCallback, onSubmit: onSubmit }) })));
};
